import axiosInstance from "../utils/axiosInstance";

export const uploadFilesApi = async (files, purpose) => {
  const body = new FormData();
  files.forEach((file) => body.append("files", file));
  body.append("purpose", purpose);
  return axiosInstance.post("/files/upload", body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadPatientArchiveFilesApi = async (files) => {
  const body = new FormData();
  files.forEach((file) => body.append("files", file));
  return axiosInstance.post("/files/patient-archive", body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadProfileImageApi = async (file) => {
  const body = new FormData();
  body.append("file", file);
  return axiosInstance.post("/files/profile", body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadPatientImageApi = async ({ patientId, file }) => {
  const body = new FormData();
  body.append("file", file);
  return axiosInstance.post(`/files/patient/${patientId}/profile`, body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const uploadPendingPatientImageApi = async (file) => {
  const body = new FormData();
  body.append("file", file);
  return axiosInstance.post("/files/patient-profile", body, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

export const downloadFileApi = async (file) => {
  const response = await axiosInstance.get(`/files/${file._id}/download`, { responseType: "blob" });
  const url = window.URL.createObjectURL(response.data);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = file.originalName || "download";
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  window.URL.revokeObjectURL(url);
};

export const getFileBlobApi = (fileId) =>
  axiosInstance.get(`/files/${fileId}/content`, { responseType: "blob" });
